<!--
    描述：场地管理 -- 右侧会议室列表
    时间：
    Created by
-->
<template>
	<div class="h100">
		<div class="operation-layout">
			<el-form label-width="100px"
					 class="w100 mt10">
				<el-row>
					<el-col :span="5">
						<el-form-item label="场地名称："
									  class="text-overflow">
							{{ adressObj.sname }}
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="场地归属单位："
									  class="text-overflow">
							{{ adressObj.tenantSname }}
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="标签："
									  class="text-overflow">
							<span class="green">{{ adressObj.tagName }}</span>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="场地地址："
									  class="text-overflow">
							{{ adressObj.detailAdd }}
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="详细地址："
									  class="text-overflow">
							{{ adressObj.address }}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="operation-main resetHeight">
				<div class="operation-header"
					 :class="{ flexEnd: adressObj.tag == '1001002' }">
					<el-button size="small"
							   type="success"
							   icon="el-icon-plus"
							   v-if="roleBtns.includes('meetingRoom-add') && adressObj.tag != '1001002'"
							   @click="addField">
						新增会议室
					</el-button>
					<div class="btnGroups">
						<el-input v-model="searchForm.sname"
								  placeholder="请输入会议室名称"
								  size="small">
							<el-button slot="append"
									   icon="el-icon-search"
									   @click="searchResult"></el-button>
						</el-input>
						<el-button type="primary"
								   class="btn-blue ml10"
								   icon="el-icon-refresh"
								   @click="resetForm"
								   size="small"></el-button>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page">
					<div class="w-table-content"
						 v-show="tableShow">
						<el-table ref="xTable"
								  :data="filterDataMeeting"
								  highlight-current-row
								  highlight-hover-row
								  height="100%"
								  border>
							<el-table-column type="index"
											 label="序号"
											 align="center"
											 width="60"></el-table-column>
							<el-table-column prop="sname"
											 label="会议室名称"
											 header-align="center"
											 width="150"
											 show-overflow-tooltip></el-table-column>
							<el-table-column prop="typeName"
											 label="会议室类型"
											 header-align="center"
											 align="left"
											 width="150"
											 show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="galleryful"
											 label="会议室容纳人数"
											 align="center"
											 width="120"
											 show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="placeName"
											 label="归属场地"
											 header-align="center"
											 width="150"
											 show-overflow-tooltip>
								<template>
									<span>{{ adressObj.sname }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="price"
											 label="会议室价格(天)"
											 width="150"
											 header-align="center"
											 align="center"
											 sortable
											 show-overflow-tooltip>
								<template slot-scope="scope">
									{{ scope.row && scope.row.price ? parseFloat(scope.row.price).toFixed(2) : '0.00' }}
								</template>
							</el-table-column>
							<el-table-column prop="configurationName"
											 label="会议室配置"
											 width="200"
											 header-align="center"
											 sortable
											 show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="applySysName"
											 label="可应用系统"
											 min-width="150"
											 header-align="center"
											 sortable
											 show-overflow-tooltip>
							</el-table-column>
							<el-table-column align="center"
											 label="场地标签"
											 show-overflow-tooltip
											 width="120">
								<template slot-scope="scope">
									{{ adressObj.tagName }}
								</template>
							</el-table-column>
							<el-table-column width="120"
											 align="center"><template slot="header">状态 </template>
								<template slot-scope="scope">
									<el-switch class="switch"
											   v-model="scope.row.status"
											   :active-value="1"
											   :inactive-value="0"
											   active-text="启用"
											   inactive-text="关闭"
											   active-color="#2671cc"
											   inactive-color="#cccccc"
											   disabled
											   :class="{ opacityHide: !roleBtns.includes('meetingRoom-enable') }"
											   @click.native.prevent="statusChange(scope.row)">
									</el-switch>
								</template>
							</el-table-column>
							<el-table-column align="center"
											 min-width="300px">
								<template slot="header">操作 </template>
								<template slot-scope="scope">
									<el-row>
										<el-button :type="adressObj.tag ==
												   '1001002'
												   ? 'primary'
												   : 'success'"
												   class="
												   table-btn"
												   round
												   plain
												   @click="editRoom(scope.row)"
												   v-if="adressObj.tag ==
												   '1001002'
												   ? roleBtns.includes('meetingRoom-edit') : roleBtns.includes('meetingRoom-check')">
											<svg-icon :icon-class="
													  adressObj.tag=='1001002'
													  ? 'form-look'
													  : 'form-edit'"></svg-icon>
											{{ adressObj.tag == "1001002" ? '查看' : '编辑' }}
										</el-button>
										<el-button type="danger"
												   icon="el-icon-delete"
												   round
												   plain
												   class="table-btn"
												   v-if="roleBtns.includes('meetingRoom-del')"
												   :disabled="adressObj.tag == '1001002'"
												   @click="delRoom(scope.row)">删除
										</el-button>
										<el-button type="success"
												   round
												   plain
												   class="table-btn"
												   @click="delCamera(scope.row)">
											<svg-icon icon-class="Camera_management"></svg-icon> 监控管理
										</el-button>
									</el-row>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="currentPage"
									   :page-sizes="pageList"
									   :page-size="pageSize"
									   :total="total"
									   layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {
	getoperateMeetingList,
	selectMeetingState,
	deleteMeeting,
} from 'api/modules/fieldManagement'
import { mapState } from 'vuex'
export default {
	components: {},
	props: {
		companyId: {
			type: String,
			default: '',
		},
		adressObj: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			filterDataMeeting: [], //会议室列表
			searchForm: {
				sname: '',
			},
			tableShow: true,
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}
			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(
					this.$getSessionItem('currentPage')
				)

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}

		this.$nextTick(() => {
			setTimeout(() => {
				this.companyId != '' ? this.getDataMeeting(this.companyId) : ''
			}, 100)
		})
	},
	methods: {
		// 获取搜索结果
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getDataMeeting(this.adressObj.id)
		},

		// 重置
		resetForm() {
			this.currentPage = 1
			this.pageSize = 10
			this.searchForm.sname = ''
			this.getDataMeeting(this.adressObj.id)
		},

		// 获取会议室列表
		getDataMeeting(id) {
			let params = Object.assign({}, this.searchForm)
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.siteId = id

			getoperateMeetingList(params)
				.then((res) => {
					this.loading = false
					this.filterDataMeeting = res.data.records
					this.currentPage = parseInt(res.data.current)
					this.total = parseInt(res.data.total)
					this.pageSize = parseInt(res.data.size)
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 新增会议室
		addField() {
			if (this.companyId == '') {
				this.$message.warning('请先选择左侧场地！')
			} else {
				this.$router.push({
					name: 'Field-management',
					query: {
						type: 'add',
					},
				})
			}
		},

		//编辑会议室
		editRoom(params) {
			this.$emit('sendId', params)

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.currentPage)
			)
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				name: 'Field-management',
				query: {
					type: 'detail',
				},
			})
		},

		//删除会议室
		delRoom(params) {
			this.$confirm('是否确认删除会议室?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteMeeting({
						id: params.id,
					})
						.then((d) => {
							if (d.data.id) {
								this.$message.success('删除成功！')
								this.searchResult()
							} else {
								this.$message.error(d.msg)
							}
						})
						.catch(() => {
							this.$message.error(d.msg)
						})
				})
				.catch(() => {
					this.$message.info('操作取消')
				})
		},

		// 会议室状态改变
		statusChange(row) {
			if (this.roleBtns.includes('meetingRoom-enable')) {
				let status = row.status == 0 ? 1 : 0
				this.$confirm('是否确认改变会议室状态?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						selectMeetingState({
							id: row.id,
							status,
						}).then((d) => {
							if (d.operationCode == 1) {
								row.status == 0
									? (row.status = 1)
									: (row.status = 0)
								this.$message.success('修改成功')
							} else {
								this.$message.error(d.msg)
							}
						})
					})
					.catch(() => {
						this.$message.info('操作取消')
					})
			} else {
				this.$message.warning('当前账号没权限进行此操作！')
			}
		},

		// 处理摄像头
		delCamera(data) {
			this.$emit('sendId', data)

			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchForm))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.currentPage)
			)
			this.$setSessionItem('pageSize', JSON.stringify(this.pageSize))

			this.$router.push({
				name: 'Field-management',
				query: {
					type: 'Camera',
					companyId: this.companyId,
					meetingId: data.id,
					siteId: data.siteId,
				},
			})
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getDataMeeting(this.adressObj.id)
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getDataMeeting(this.adressObj.id)
		},
	},
	computed: {
		...mapState('app', {
			clientSize: (state) => state.clientSize,
			isBack: (state) => state.isBack,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		clientSize(val, oldval) {
			if (val.height != oldval.height) {
				this.tableShow = false
				setTimeout(() => {
					this.tableShow = true
				}, 50)
				setTimeout(() => {
					this.$refs.xTable.doLayout()
				}, 300)
			}
		},
	}
}
</script>
<style lang="less" scoped>
.w-table-layout {
	.switch {
		/deep/ .el-switch__label--right span {
			margin-left: -10px;
		}
	}
	.b-text {
		color: #2671cc;
		cursor: pointer;
	}
	.r-text {
		color: red;
		cursor: pointer;
	}
	.is-disabled {
		cursor: not-allowed;
	}

	.text-overflow {
		/deep/ .el-form-item__content {
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.operation-header {
		height: 45px;
		justify-content: space-between;
	}

	.operation-container {
		height: calc(~'100% - 45px') !important;
	}

	.btnGroups {
		display: flex;
		align-items: center;
	}
	.el-switch.is-disabled {
		opacity: 1;
	}

	/deep/ .el-switch.is-disabled .el-switch__core,
	/deep/ .el-switch.is-disabled .el-switch__label {
		cursor: pointer !important;
	}

	.green {
		color: green;
		font-weight: bold;
	}

	/deep/ .el-table__header-wrapper {
		tr > th {
			padding: 6px 0 !important;
			height: 50px !important;
		}
	}
	.resetHeight {
		height: calc(~'100% - 120px') !important;
	}
	.flexEnd {
		justify-content: flex-end;
	}
}
</style>
